import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ConexionSistemaContabilidad;

export interface Props {
    value: Entity;
    label: string;
    error?: kea.FieldError;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        BaseDatosId: validation.required,
        Contraseña: validation.required,
        URL: validation.required,
        Usuario: validation.required,
        ClaveEmpresa: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class ConfigSistemaContabilidad extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onProbarConexion = async () => {
        const errorConexion= await resources.ConfigSistema.ProbarConexionContabilidad();
        if(errorConexion == null){
            await kea.message("Conexión exitosa", "", "success");
        } else {
            await kea.message("Error de conexión", errorConexion, "error");
        }
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const Check = getField(kea.Checkbox);
        return (
            <div>
                <kea.Panel title={this.props.label} error={this.props.error}>
                    {kea.autogrid(3, [
                        <Check field="Deshabilitar" label="Deshabilitar" />,
                        <Text field="URL" label="Url" />,
                        <Text field="BaseDatosId" label="Id. de la base de datos" />,
                        <Text field="Usuario" label="Usuario" />,
                        <Text field="Contraseña" label="Contraseña" />,
                        <Number field="ClaveEmpresa" label="Clave empresa" format="int" />,
                    ])}

                    <kea.Button onClick={this.onProbarConexion}>
                        Probar conexión
                    </kea.Button>
                </kea.Panel>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/configuraciones/edit/components/contabilidad/configsistema.tsx